<script>

import {SpeakerMixin} from "../lib/speaker-utils.js"

export default {
  mixins: [SpeakerMixin],
  props: {
    contact: {type: Object, required: true},
  },

  computed: {
    directChannel() {
      return this.$storage.getDirectChannel(this.contact.uuid)
    },
    isSpeaker() {
      return this.personRoles(this.contact.speaker).isSpeaker
    },
    isModerator() {
      return this.personRoles(this.contact.speaker).isChair
    },
    isPanelist() {
      return this.personRoles(this.contact.speaker).isPanelist
    },
  },

  methods: {
    displayName(contact) {
      return `${contact.last_name || ''} ${contact.first_name || ''}`.trim() || contact.username
    }
  }
}

</script>

<template>

  <div class="list-group-item">
      <div class="d-flex flex-row align-items-start">
        <img :src="contact.profile_image" class="avatar me-2" />
        <div class="flex-fill">
          <div class="d-flex flex-wrap align-items-center gap-1">
            <h4 class="card-title mb-0 me-1">{{displayName(contact)}}</h4>
            <span v-if="isSpeaker" class="badge bg-secondary c-role-badge">Speaker</span>
            <span v-if="isModerator" class="badge bg-warning text-dark c-role-badge">Moderator</span>
            <span v-if="isPanelist" class="badge bg-primary c-role-badge">Panel</span>
            <span v-if="contact.is_booth_staff" class="badge bg-info text-dark c-role-badge">Aussteller</span>
            <span v-if="contact.is_visitor" class="badge bg-light text-dark border c-role-badge">Besucher</span>
            <span v-if="directChannel && directChannel.numUnreadMessages"
             class="badge bg-danger c-role-badge">
              <i class="far fa-envelope"></i> {{directChannel.numUnreadMessages}}
            </span>
          </div>
          <div v-if="contact.job_title" class="text-muted">
            <small>{{contact.job_title}}</small>
          </div>
          <div v-if="contact.company_name" class="text-muted">
            <small>{{contact.company_name}}</small>
          </div>
          <div v-if="contact.interests && contact.interests.length" class="mt-1 d-flex flex-wrap gap-1 c-interests">
            <span v-for="cat in contact.interests" :key="cat.id"
             class="badge bg-light text-dark border c-interest-tag">{{ cat.name }}</span>
            <span v-if="contact.interests.length > 2"
             class="badge bg-light text-dark border c-interest-more">+{{ contact.interests.length - 2 }}</span>
          </div>
        </div>
      </div>
  </div>

</template>

<style scoped>

.avatar {
  height:30px;
  width:30px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

.badge {
  border-radius: .5rem;
  height: fit-content;
}

/* Role badges sit inline next to the name and wrap when there are several. */
.c-role-badge {
  font-size: .62rem;
  padding: .3em .5em;
}

/* Interest tags are secondary info -- keep them compact. */
.c-interest-tag, .c-interest-more {
  font-size: .68rem;
  font-weight: 500;
  padding: .25em .5em;
}

/* Show at most the first two interest tags on ALL screen sizes -- long
   tag lists clutter the list view. The "+N" chip indicates the rest
   (full list is visible in the contact detail). */
.c-interests .c-interest-tag:nth-of-type(n+3) {
  display: none;
}

</style>